import { all } from "axios";

export const all_routes = {
    //Home Modules
    homeone: "/index",
    hometwo: "/index-2",
    homethree: "/index-3",
    homefour: "/index-4",
    homefive: "/index-5",
    homesix: "/home",

    // Institution Modules
    institutionDetails: "/institution/institution-details/:id",
    institutionHome: "/institution",
    institutionDashboard: "/institution/institution-dashboard",
    institutionPrograms: "/institution/institution-programs",
    institutionApplications: "/institution/applications",
    institutionProfile: "/institution/institution-profile",
    institutionSettings: "/institution/institution-settings",
    institutionChangePassword: "/institution/institution-change-password",
    institutionBulkUpload: "/institution/bulk-upload",
    institutionProgramsBulkUpload: "/institution/bulk-upload-programs",

    // Program Modules
    allProgramsGrid: "/program/programs-grid",
    allProgramsList: "/program/programs-list",
    programDetails: "/program/program-details/:id",

    // Recruiters Modules
    recruiterHome: "/recruiter",
    recruiterDashboard: "/recruiter/recruiter-dashboard",
    recruiterStudents: "/recruiter/recruiter-students",
    recruiterApplications: "/recruiter/recruiter-applications",
    recruiterSettings: "/recruiter/recruiter-settings",
    recruiterBusinessProfile: "/recruiter/recruiter-business-profile",
    recruiterCommissions: "/recruiter/recruiter-commissions",
    recruiterDocuments: "/recruiter/recruiter-documents",
    recruiterNotifications: '/recruiter/recruiter-notifications',
    recruiterAccountManagers: "/recruiter/recruiter-account-managers",
    recruiterChangePassword: "/recruiter/recruiter-change-password",

    //Course Modules
    courseGrid: "/course/course-grid",
    courseList: "/course/course-list",
    courseDetails: "/course/course-details",
    courseDetails2: "/course/course-details-2",
    courseCategory: "/course/course-category",
    courseCategory2: "/course/course-category-2",
    courseCategory3: "/course/course-category-3",
    courseResume: "/course/course-resume",
    courseWatch: "/course/course-watch",
    courseCart: "/course/cart",
    courseCheckout: "/course/checkout",
    addNewCourse: "/course/add-course",

    //Instructor Modules
    instructorDashboard: "/instructor/instructor-dashboard",
    instructorProfile: "/instructor/instructor-profile",
    instructorCourse: "/instructor/instructor-course",
    instructorCourseGrid: "/instructor/instructor-course-grid",
    instructorAnnouncements: "/instructor/instructor-announcements",
    instructorAssignment: "/instructor/instructor-assignment",
    instructorQuiz: "/instructor/instructor-quiz",
    instructorQuizResult: "/instructor/instructor-quiz-results",
    instructorCertificate: "/instructor/instructor-certificate",
    instructorEarning: "/instructor/instructor-earnings",
    instructorPayout: "/instructor/instructor-payout",
    instructorStatements: "/instructor/instructor-statements",
    instructorMessage: "/instructor/instructor-message",
    instructorTickets: "/instructor/instructor-tickets",
    instructorChangePassword: "/instructor/instructor-change-password",
    instructorPlan: "/instructor/instructor-plans",
    instructorSocialProfiles: "/instructor/instructor-social-profiles",
    instructorLinkedAccounts: "/instructor/instructor-linked-accounts",
    instructorNotification: "/instructor/instructor-notifications",
    instructorIntegrations: "/instructor/instructor-integrations",
    instructorWithdraw: "/instructor/instructor-withdraw",
    instructorWishlist: "/instructor/instructor-withdraw",
    instructorReviews: "/instructor/instructor-withdraw",
    instructorQuizAttempts: "/instructor/instructor-withdraw",
    instructorOrders: "/instructor/instructor-withdraw",
    instructorChat: "/instructor/instructor-withdraw",
    instructorReferral: "/instructor/instructor-withdraw",
    instructorQA: "/instructor/instructor-quiz-questions",
    instructorsettings: "/instructor/instructor-settings",

    // Student Modules
    studentHome: "/student",
    studentProgramsSchools: "/student/student-programs-schools",
    studentDashboard: "/student/student-dashboard",
    studentApplications: "/student/student-applications",
    studentProfile: "/student/student-profile",
    studentsGrid: "/instructor/students",
    studentsDetails: "/instructor/students-details",
    studentsList: "/instructor/student-list",
    studentOrderHistory: "/student/student-order-history",
    studentMessage: "/student/student-messages",
    studentCourses: "/student/student-courses",
    studentCertificates: "/student/student-certificates",
    studentReviews: "/student/student-reviews",
    studentWishlist: "/student/student-wishlist",
    studentQuiz: "/student/student-quiz",
    studentQuizQuestion: "/student/student-quiz-questions",
    studentReferral: "/student/student-referral",
    studentTickets: "/student/student-tickets",
    studentSettings: "/student/student-settings",
    studentChangePassword: "/student/student-change-password",
    studentSocialProfile: "/student/student-social-profile",
    studentLinkedAccounts: "/student/student-linked-accounts",
    studentNotification: "/student/student-notifications",
    studentBillingAddress: "/student/student-billing-address",
    studentVisa: "/student/student-visa-study-permit",
    studentEducationHistory: "/student/student-education-history",
    studentWorkExperience: "/student/studentwork-experience",
    studentTestScores: "/student/student-test-scores",
    studentDocuments: "/student/student-documents",
    studentNotes: "/student/student-notes",
    'studentActivity': "/student/student-activity",

    cart: "/cart",
    login: "/login",
    register: "/register",
    forgotpassword: "/forgot-password",
    setpassowrd: "/set-password",
    otp: "/otp",
    lockscreen: "/lock-screen",
    privacyPolicy: "/pages/privacy-policy",
    termsConditions: "/terms-conditions",
    contactUs: "pages/contact-us",
    about_us: "/pages/about-us",
    invoices: "/pages/invoices",
    FAQ: "/pages/faq",
    pricingPlan: "/pages/pricing-plan",
    Error404: "/pages/error-404",
    Error500: "/pages/error-500",
    underconstruction: "/pages/under-construction",
    comingSoon: "/pages/coming-soon",
    institutionregister: "institution-register",
    becomeAnInstructor: "/pages/become-an-instructor",
    instructorList: "/pages/instructor-list",
    instructorGrid: "/pages/instructor-grid",
    instructorDetails: "/pages/instructor-details",
    notification: "/pages/notifications",
    testimonials: "/pages/testimonials",

    blogGrid: "/blog/blog-grid",
    blogGrid2: "/blog/blog-2-grid",
    blogGrid3: "/blog/blog-3-grid",
    blogDetails: "/blog/blog-details",
    blogCarousal: "/blog/blog-carousal",
    blogMasonry: "/blog/blog-masonry",
    blogLeftSidebar: "/blog/blog-left-sidebar",
    blogRightSidebar: "/blog/blog-right-sidebar",
    blogDetailsLeftSidebar: "/blog/blog-details-left-sidebar",
    blogDetailsRightSidebar: "/blog/blog-details-right-sidebar",
};
